(function () {
    'use strict';

    angular
        .module('app.privacy', [
            'app.core',
            'utils'
        ]);
})();